 const keyTypeWithPath = {
    1: 'FSEMasterKey',
    2: 'OnedayKey',
    3: 'AdminITKey',
    4: 'Pentero',
    5: 'Biomed',
    6: 'Factory',
    7: 'DareKey'
  };
  export default keyTypeWithPath;